import { CHIP_TYPES } from '@skyscanner/backpack-web/bpk-component-chip';
import {
  BpkSingleSelectChipGroup,
  CHIP_GROUP_TYPES,
} from '@skyscanner/backpack-web/bpk-component-chip-group';
import BpkSkeleton, {
  SKELETON_TYPES,
  SIZE_TYPES,
} from '@skyscanner/backpack-web/bpk-component-skeleton';

import type {
  GalleryFilterItemClickEventHandler,
  ImagesGalleryCategory,
} from '../../types';
import type { I18nService } from '@shared/types/i18n';
import type { Nullable } from '@shared/types/utils';

import STYLES from './Filters.module.scss';

import BpkBreakpoint, { BREAKPOINTS } from '@shared/ui/common/BpkBreakpoint';
import { withI18n } from '@shared/ui/contexts/i18n';

type Props = {
  total: number;
  onFilterClick: GalleryFilterItemClickEventHandler;
  selectedFilter?: Nullable<string>;
  categories?: ImagesGalleryCategory[];
  isLoading?: boolean;
  i18n: I18nService;
};

const Filters = ({
  categories,
  i18n,
  isLoading,
  onFilterClick,
  selectedFilter,
  total,
}: Props) => {
  const chips = [
    {
      name: null,
      displayName: i18n.translate(`ImageGalleryFilters_label_all`, {
        number: total,
      }),
    },
    ...(categories ?? []),
  ].map(({ displayName, name }) => ({
    name,
    text: displayName,
    selected: selectedFilter === name,
  }));

  return (
    <div className={STYLES.Filters}>
      {isLoading ? (
        <div className={STYLES.Filters__skeletons}>
          {chips.slice(0, 3).map(({ name }) => (
            <BpkSkeleton
              key={name}
              type={SKELETON_TYPES.headline}
              size={SIZE_TYPES.large}
            />
          ))}
        </div>
      ) : (
        <BpkBreakpoint query={BREAKPOINTS.MOBILE}>
          {(isMobile: boolean) => (
            <BpkSingleSelectChipGroup
              type={CHIP_GROUP_TYPES.rail}
              chipStyle={isMobile ? CHIP_TYPES.onImage : CHIP_TYPES.default}
              chips={chips}
              selectedIndex={chips.findIndex(
                ({ name }) => name === selectedFilter,
              )}
              leadingNudgerLabel={i18n.translate(
                'Offer_filters_chip_group_leading_nudger_label',
              )}
              trailingNudgerLabel={i18n.translate(
                'Offer_filters_chip_group_trailing_nudger_label',
              )}
              onItemClick={(_chip, _selected, index) =>
                onFilterClick(chips[index].name)
              }
            />
          )}
        </BpkBreakpoint>
      )}
    </div>
  );
};

export default withI18n(Filters);
